import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13f6bd53&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/index1.less?vue&type=style&index=0&id=13f6bd53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f6bd53",
  null
  
)

component.options.__file = "index.vue"
export default component.exports